import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { IPayVisitInp } from 'src/app/shared/interfaces/payVisitInp';
import { IVisitDetai } from 'src/app/shared/interfaces/visitDetail';
import { EVisitType } from 'src/app/shared/interfaces/visitType-enum';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-visit-detail',
  templateUrl: './visit-detail.component.html',
  styleUrl: './visit-detail.component.css'
})
export class VisitDetailComponent implements OnInit {

  visit: IVisitDetai;
  visitTypess = EVisitType;
  viditId: any;
  isAccepted: boolean = false;
  isEnough: boolean = false;
  payVisitModel: IPayVisitInp = {
    visitId: 0,
    payByWallet: false,
    url: ''
  }

  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.viditId = this.route.snapshot.params.visitId;

    this.getVisitPreInvoice();
  }

  disableWallet(): boolean {
    const payAmount = this.visit.price - this.visit.discount;
    if (this.visit.walletBalance < payAmount) {
      return true
    } else {
      return false
    }
  }

  getVisitPreInvoice() {
    this.apiService.apiCall('get', '/api/PatientsVisitActive/'+ this.viditId +'/GetVisitPreInvoiceById').subscribe((res: any) => {
      console.log(res);
      
      this.visit = res.body.model;

      const payAmount = this.visit.price - this.visit.discount;
      if(this.visit.walletBalance>=payAmount) {
        this.isEnough = true;
      }
    })
  }

  payVisit() {    
    if(!this.isAccepted) {
      this.messageService.add({severity: 'warn', summary:  'توجه', detail: 'ابتدا قوانین و مقررات را مطالعه و سپس تایید فرمایید.'});
      return false;
    }
    this.payVisitModel = {
      visitId: this.viditId,
      payByWallet: this.isEnough,
      url: window.location.origin+'/visit-link/'+ this.viditId
      // url: this.visit.visitType==this.visitTypess.TextVisit? window.location.origin+'/visit-link/'+ this.viditId :window.location.origin+'/user/appointment'
    }
    console.log(this.payVisitModel);
    
    this.apiService.apiCall('post', '/api/PatientsVisitActive/PayVisit', this.payVisitModel).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {
        if (res.body.model.zarinUrl == null || this.isEnough) {
          this.router.navigate(['/visit-link/' + this.viditId])
        } else {
          window.location.href = res.body.model.zarinUrl;
        }
      } else {
        this.messageService.add({severity: 'error', summary:  'خطا', detail: res.body.message});
      }
    })
  }

  convertUTCMinutesToLocal(utcMinutes: number): number | any {
    // Get the current date (ignoring time) in UTC
    const utcDate = new Date();
    utcDate.setUTCHours(0, 0, 0, 0); // Reset to 00:00 UTC
  
    // Add UTC minutes to the date
    utcDate.setUTCMinutes(utcMinutes);
  
    // Convert to local time
    const localHours = utcDate.getHours(); // Local hours
    const localMinutes = utcDate.getMinutes(); // Local minutes
  
    // Convert local time to total minutes from 00:00 local time
    return this.calculateTime(localHours * 60 + localMinutes);
  }

  calculateTime(time) {
    const hours = Math.floor(time / 60);
    const minutes = time % 60;
    // Format the time as HH:mm
    const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    return timeString
  }

}
